var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-lg-none"},[_c('i',{staticClass:"fa fa-bars fa-lg toggle",on:{"click":_vm.toggleSidebar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }